import { default as styled } from 'styled-components';

export const Page = styled.div`
  min-height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: ${(props) => props.theme.palette.contrastInvert};
`;
